import {
  Slider as HeroSlider,
  SliderProps as HeroUISliderProps,
} from "@heroui/react";

export type SliderProps = HeroUISliderProps;

export function Slider(props: SliderProps) {
  return <HeroSlider {...props} />;
}

Slider.displayName = "RecareUI.Slider";
